import ScreenKey from '@/Enums/Screens/ScreenKey.enum';

export const isReportingScreenEnabled = (value: unknown) => Boolean(value);

/**
 * Unified Reporting and the legacy Reporting Dashboard are mutually exclusive —
 * for everyone except Ribeye admins, who run both surfaces side by side while
 * Unified Reporting is in beta and may hold one, the other, or both (#4245).
 *
 * Custom Dashboards is its own independent grant (#4441) — no longer bundled
 * with Unified Reporting, so toggling either of these two leaves it alone.
 *
 * Enforced on the toggle rather than on save, so switching stays a visible,
 * undoable admin action and never mutates stored screens (see #2189).
 */
export const applyReportingScreenBundling = (
  screen: ScreenKey,
  enabled: boolean,
  setValue: (name: string, value: false) => void,
  { allowBoth = false }: { allowBoth?: boolean } = {},
) => {
  if (screen === ScreenKey.REPORTING_V2 && enabled && !allowBoth) {
    setValue(`accessManagement.${ScreenKey.REPORTING_DASHBOARD}`, false);
  }

  // Turning legacy on only displaces Unified Reporting when the two are
  // exclusive; for a Ribeye admin it must leave the other grant alone.
  if (screen === ScreenKey.REPORTING_DASHBOARD && enabled && !allowBoth) {
    setValue(`accessManagement.${ScreenKey.REPORTING_V2}`, false);
  }
};
